export function wrapInQuotes(string: string) {
  return "\"" + string + "\""
}
